import styled from 'styled-components';
export default styled.p `
	color: var(--theme-article-text-color, #3a3a3a);
	font-size: 10px;
	font-style: italic;
	letter-spacing: 0.02px;
	line-height: 1.5;
	margin: -12px 18px 18px !important;
	position: relative;
`;
